import React, { Component } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import default_bg from "../img/default-bg.jpg";
import { prefixImageUrl } from "../utils/imageUrl";
import { BusinessLink } from "../Business/BusinessList";
import { Address, Other } from "../Business/BusinessPage";


const Wrapper = styled("div")`
  padding: 2rem 2rem 0 2rem;
  width: 100%;
  display: flex;
  ${(props) => props.theme.bp.below.lg} {
    padding: 1rem;
  }

  .inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 1rem;
    gap: ${(props) => props.gap};

    ${(props) => props.theme.bp.below.lg} {
      flex-direction: column;
      gap: 0;
    }
  }
`;
const ImageColumn = styled("div")`
  flex: 1;
  border-radius: ${(props) => props.borderRadius};
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  ${(props) => props.theme.bp.below.lg} {
    flex: none;
    width: 100%;
    min-height: 250px;
    max-height: 40vh;
    border-radius: 0;
  }
`;
const ContentColumn = styled("div")`
  background: ${(props) => props.theme.colors.primary};
  flex: 1;
  border-radius: ${(props) => props.borderRadius};

  ${(props) => props.theme.bp.below.lg} {
    flex: none;
    width: 100%;
    border-radius: 0;
  }
`;

export const HeaderContent = styled("div")`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 3rem;
  color: white;

  ${(props) => props.theme.bp.below.lg} {
    padding: 2rem;
    justify-content: flex-start;
  }

  h1 {
    font-size: 2.5rem;
    max-width: 400px;
    margin-bottom: .5rem;
    ${(props) => props.theme.bp.below.lg} {
      font-size: 1.8rem;
      max-width: 100%;
    }
  }
  div {
    max-width: 550px;
    line-height: 1.5;
    ${(props) => props.theme.bp.below.lg} {
       max-width: 100%;
    }
    a {
      color: white;
      text-decoration: underline;
    }
  }

  .subTitle {
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
    font-family: ${(props) => props.theme.fonts.body};
  }
`;

const Button = styled(Link)`
  background: white;
  color: ${(props) => props.theme.colors.primary}!important;
  padding: 1rem 2rem;
  border-radius: 50px;
  text-decoration: none!important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.1em;
  font-size: 14px;
  display: inline-block;
`;

class PageHeader extends Component {
  render() {
    const { pageData, propertyData, propertyContent, longContent, gap = "1rem" } = this.props;
    const borderRadius = gap === "0" ? "0" : "1rem";
    const hasFallbackImage = pageData.image.url.includes("default-bg") ? true : false;

    return (
      <Wrapper gap={gap}>
        <div className="inner">
          <ImageColumn borderRadius={borderRadius}>
            <img src={hasFallbackImage ? default_bg : prefixImageUrl(pageData.image.url)} alt={pageData.title} />
          </ImageColumn>
          <ContentColumn borderRadius={borderRadius}>
            <HeaderContent>
              <div className="column">
                <h1>{pageData.headTitle || pageData.title}</h1>
              </div>
              <div className="column">
                <div dangerouslySetInnerHTML={{ __html: pageData.excerpt }} />
                {propertyData && !longContent && (
                  <>
                    <div dangerouslySetInnerHTML={{ __html: propertyContent }} />
                    {propertyData?.address && <Address {...propertyData} />}
                    <Other {...propertyData} />
                    {propertyData?.logo?.url && <img src={prefixImageUrl(propertyData.logo.url)} alt={propertyData.title} />}
                    {propertyData.website !== null && (
                      <BusinessLink
                        static="1"
                        inline="1"
                        rel="noopener noreferrer"
                        target="_blank"
                        href={propertyData.website}
                      >
                        {propertyData.website
                          .replace("http://", "")
                          .replace("https://", "")
                          .replace("www.", "")}
                      </BusinessLink>
                    )}
                  </>
                )}

                {pageData.headLink && (
                  <Button to={pageData.headLink}>{pageData.headLinkText}</Button>
                )}
              </div>
            </HeaderContent>
          </ContentColumn>
        </div>
      </Wrapper>
    );
  }
}

export default PageHeader;
